import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="relative py-20 md:py-28 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase mb-3">
            Quick Navigation
          </p>
          <h2 className="section-title mb-3">Browse Product Categories</h2>
          <p className="section-subtitle mx-auto">
            Jump directly to any product category on the main website. All links open for a seamless shopping experience.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="bg-white border border-background-200 text-foreground-700 font-label text-sm px-5 py-2.5 rounded-full cursor-pointer transition-all duration-300 hover:bg-foreground-900 hover:text-white hover:border-foreground-900 hover:scale-[1.03] active:scale-[0.97] whitespace-nowrap"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              {cat.name}
            </a>
          ))}
        </div>

        <div id="about" className="mt-20 max-w-3xl mx-auto text-center">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase mb-4">
            About SuperBuy Spreadsheet
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
            What Is SuperBuy Spreadsheet?
          </h2>
          <div className="space-y-4 text-foreground-600 font-body text-sm md:text-base leading-relaxed">
            <p>
              SuperBuy Spreadsheet is a structured product research resource that helps shoppers organize
              product links, categories, comparisons and buying information in one convenient place. Rather
              than spending hours scrolling through countless product listings, users can explore organized
              spreadsheets and curated guides to quickly discover popular items across multiple categories.
            </p>
            <p>
              Our platform serves as an independent bridge between curious shoppers and quality products.
              Whether you are hunting for the latest sneaker releases, browsing streetwear collections,
              or comparing accessories from different sources, SuperBuy Spreadsheet streamlines the
              entire discovery process. The resources are designed to be beginner-friendly while offering
              enough depth for experienced shoppers who demand detailed product research and side-by-side
              comparisons before making purchasing decisions.
            </p>
            <p>
              What truly sets SuperBuy Spreadsheet apart is the combination of structured data and
              human-curated insights. Every category is thoughtfully organized, every guide is written
              with real shopping experience in mind, and every comparison table is built to help you
              make confident, informed choices without the overwhelm.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}